import { Button } from "@/modules/shared/ui/components/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/modules/shared/ui/components/dialog"
import type { BillingPlanDto } from "@/modules/subscriptions/dtos/billing-plan.dto"
import type { SubscriptionStatusDto } from "@/modules/subscriptions/dtos/subscription-status.dto"

interface SwitchPlanConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  activeSubscription: SubscriptionStatusDto | null
  selectedPlan: BillingPlanDto | null
  isLoading: boolean
  onConfirm: () => void
}

export function SwitchPlanConfirmationModal({
  open,
  onOpenChange,
  activeSubscription,
  selectedPlan,
  isLoading,
  onConfirm,
}: SwitchPlanConfirmationModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Switch Plan</DialogTitle>
          <DialogDescription>
            This will cancel your current{" "}
            <strong>{activeSubscription?.planName}</strong> subscription and
            activate the new <strong>{selectedPlan?.name}</strong> plan. Are
            you sure you want to continue?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Keep Current Plan
          </Button>
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading ? "Processing..." : "Yes, Switch Plan"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
